import { NgModule } from "@angular/core";
import { ToeReportTemplateEditComponent } from "./toe-report-template-edit/toe-report-template-edit.component";
import { Route, RouterModule } from "@angular/router";
import { ToeReportTemplateListComponent } from "./toe-report-template-list/toe-report-template-list.component";
import { PartialsModule } from "src/app/views/partials/partials.module";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { ReactiveFormsModule } from "@angular/forms";
import { DragDropModule } from '@angular/cdk/drag-drop'
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { DraggableModule } from "../draggable/draggable.module";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSelectModule } from '@angular/material/select'
import { ToeReportTemplateFormComponent } from "./toe-report-template-form/toe-report-template-form.component";
import { ToeReportTemplateEditModalComponent } from "./toe-report-template-edit-modal/toe-report-template-edit-modal.component";
import { MatDialogModule } from "@angular/material/dialog";
import { ToeReportTemplateRoutingModule } from "./toe-report-template-routing.module";
import { ToeReportTemplateComponent } from "./toe-report-template.component";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PartialsModule,
    RouterModule,

    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatTableModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    DragDropModule,
    DraggableModule,
    MatSelectModule,
    MatDialogModule
  ],
  declarations: [
    ToeReportTemplateComponent,
    ToeReportTemplateListComponent,
    ToeReportTemplateEditComponent,
    ToeReportTemplateFormComponent,
    ToeReportTemplateEditModalComponent
  ],
  exports: [
    ToeReportTemplateEditModalComponent
  ]
})
export class ToeReportTemplateModule {}